import React from 'react';
import { PieChart, Pie, Cell, Label } from 'recharts';

const ApprovalGauge = ({ low, high }) => {
  const primaryColor = '#4A90E2';   // Your branded blue
  const neutralColor = '#E0E7FF';   // Complementary light shade

  const getColor = (value) =>
    value >= low && value <= high ? primaryColor : neutralColor;

  const data = Array.from({ length: 20 }, (_, i) => {
    const value = i * 5;
    return {
      value: 5,
      fill: getColor(value + 2.5),
    };
  });

  return (
    <PieChart width={200} height={130} margin={{ top: 40 }}>
      <Pie
        data={data}
        startAngle={180}
        endAngle={0}
        innerRadius={45}
        outerRadius={65}
        dataKey="value"
        stroke="none"
      >
        {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={entry.fill} />
        ))}
        <Label
          value="Approval Odds"
          position="center"
          offset={-10}
          fontSize={13}
          fill="#555"
        />
      </Pie>
      <text x={10} y={100} fontSize={11} fill="#888">{'<5%'}</text>
      <text x={100} y={15} fontSize={11} fill="#888" textAnchor="middle">{'50%'}</text>
      <text x={190} y={100} fontSize={11} fill="#888" textAnchor="end">{'>95%'}</text>
    </PieChart>
  );
};

export default ApprovalGauge;
